"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let BtnDeleteResource = class BtnDeleteResource extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    resource;
    onResource(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("resource");
    }
    disabled;
    onDisabled(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("disabled");
    }
    noIcon;
    onNo_icon(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("noIcon");
    }
    noText;
    onNo_text(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("noText");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    tooltip;
    onTooltip(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("tooltip");
    }
    dialogHeader;
    onDialog_header(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("dialogHeader");
    }
    dropdownItem;
    onDropdown_item(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("dropdownItem");
    }
    variant;
    onVariant(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("variant");
    }
    messages;
    ux;
    dataMembers = ['messages', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                messages: {
                    text: this.$fn.pgettext("BtnDeleteResource", "Delete"),
                    tooltip: this.$fn.pgettext("BtnDeleteResource|Tooltip", "Delete"),
                },
                ux: null,
            },
        };
    }
    get isDisabled() {
        if (this.loaded) {
            return this.disabled != null ? this.disabled : (this.resource.meta && this.resource.meta.deletable && this.resource.meta.deletable.result === false ? true : false);
        }
        return null;
    }
    get currentTooltip() {
        if (this.loaded) {
            return _.get(this.resource, "meta.deletable.message", this.tooltip || this.messages.tooltip);
        }
        return null;
    }
    async act_7315092382398562_emit_2374_getActionArgs($event) {
        return {
            event: "success",
        };
    }
    async act_7315092382398562_resource_2372_getActionArgs($event) {
        return {
            method: "delete",
            target: this.resource,
            data: { etag: this.resource.etag },
        };
    }
    async act_7315092382398562_resource_2372_getConfirm($event) {
        return {
            header: this.dialogHeader,
            message: this.$fn.gettext("Please confirm delete."),
            btnOk: this.$fn.gettext("Delete"),
            severity: "warning",
        };
    }
    async evh_7315092382398562_clickPreventStop(event, scope) {
        return await this.actions.evh_7315092382398562_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_emit_2374 = new core_1.actions.EmitAction({
            actionArgs: this.act_7315092382398562_emit_2374_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_success_2373 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_emit_2374,
            event: "success",
            displayName: "emit",
        });
        const act_7315092382398562_resource_2372 = new core_1.actions.ResourceAction({
            actionArgs: this.act_7315092382398562_resource_2372_getActionArgs,
            confirm: this.act_7315092382398562_resource_2372_getConfirm,
            displayName: "delete",
            events: [evh_7315092382398562_success_2373],
        });
        const evh_7315092382398562_clickPreventStop_2371 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_resource_2372,
            event: "click.prevent.stop",
            displayName: "delete",
        });
        const evh_7315092382398562_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_clickPreventStop_2371],
        });
        return {
            act_7315092382398562_emit_2374,
            evh_7315092382398562_success_2373,
            act_7315092382398562_resource_2372,
            evh_7315092382398562_clickPreventStop_2371,
            evh_7315092382398562_clickPreventStop,
            delete: act_7315092382398562_resource_2372,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], BtnDeleteResource.prototype, "resource", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('resource'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], BtnDeleteResource.prototype, "onResource", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
        default: null,
    }),
    __metadata("design:type", Boolean)
], BtnDeleteResource.prototype, "disabled", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('disabled'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], BtnDeleteResource.prototype, "onDisabled", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
        default: false,
    }),
    __metadata("design:type", Boolean)
], BtnDeleteResource.prototype, "noIcon", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('noIcon'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], BtnDeleteResource.prototype, "onNo_icon", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
        default: false,
    }),
    __metadata("design:type", Boolean)
], BtnDeleteResource.prototype, "noText", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('noText'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], BtnDeleteResource.prototype, "onNo_text", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "sm",
    }),
    __metadata("design:type", String)
], BtnDeleteResource.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], BtnDeleteResource.prototype, "onSize", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], BtnDeleteResource.prototype, "tooltip", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('tooltip'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], BtnDeleteResource.prototype, "onTooltip", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], BtnDeleteResource.prototype, "dialogHeader", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('dialogHeader'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], BtnDeleteResource.prototype, "onDialog_header", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
        default: false,
    }),
    __metadata("design:type", Boolean)
], BtnDeleteResource.prototype, "dropdownItem", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('dropdownItem'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], BtnDeleteResource.prototype, "onDropdown_item", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "light",
    }),
    __metadata("design:type", String)
], BtnDeleteResource.prototype, "variant", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('variant'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], BtnDeleteResource.prototype, "onVariant", null);
BtnDeleteResource = __decorate([
    (0, vue_property_decorator_1.Component)()
], BtnDeleteResource);
exports.default = BtnDeleteResource;
vue_property_decorator_1.Vue.component("BtnDeleteResource", BtnDeleteResource);
